import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import { MARKETING_CENTER_PATH } from '@constant'

export default class extends Component {
  render() {
    const header = window.location.hash.split('/').includes('caseExample')
      ? [<Link to={MARKETING_CENTER_PATH}>服务市场</Link>, '优秀范例']
      : ''

    return (
      <HeaderView
        contentStyle={{ padding: 0 }}
        title={
          window.location.hash.split('/').includes('caseExample')
            ? '优秀范例'
            : ''
        }
        header={header}
      >
        {this.props.children}
      </HeaderView>
    )
  }
}
